import React, { PureComponent } from 'react';
import { connect } from 'dva';
import { FormattedMessage, injectIntl } from 'react-intl';
import {
  Button,
  Icon,
  Input,
  message,
  Modal,
  Select,
  Table,
  Tree,
  Upload
} from 'antd';
import './DeptUserManage.less';
import DeptAddEdit from './DeptAddEdit';
import UserAddEdit from './UserAddEdit';
import { OperateSpan } from '../../../components/Widgets';
import { ADMIN_USER_ID, ROLES_KEY, USER_FROM } from '../../../utils/constants';
import IconTip from '../../../components/IconTip';
import { getSign } from 'virsical-sign';

const Option = Select.Option;
const TreeNode = Tree.TreeNode;

class DeptUserManage extends PureComponent {
  constructor() {
    super();
    this.state = {
      deptAddEditValue: {},
      deptAddEditParent: {},
      addEditUser: {}
    };
  }

  render() {
    const {
      allDept,
      deptAddEditStatus,
      userAddEditStatus,
      users,
      current,
      pageSize,
      total,
      allRoles,
      keyType,
      keyword,
      intl,
      i18n
    } = this.props;
    const _this = this;
    const { deptAddEditValue, deptAddEditParent, addEditUser } = this.state;
    const uploadPropsUrl = '/syncuser/userInfo/importUser?lang=' + i18n.locale;
    const uploadProps = {
      showUploadList: false,
      name: 'uploadFile',
      action: uploadPropsUrl,
      multiple: false,
      headers: {
        token: sessionStorage.getItem('token'),
        sign: getSign(uploadPropsUrl, sessionStorage.getItem('token'))
      },
      onChange(info) {
        if (info.file.status !== 'uploading') {
          // console.log(info.file, info.fileList);
        }
        if (info.file.status === 'done') {
          const { errorMsg, status, resultMsg, msg } = info.file.response;
          if (status === 0) {
            if (errorMsg == '') {
              message.success(`${resultMsg}`);
            } else {
              Modal.error({
                content: `${errorMsg ||
                _this.props.intl.formatMessage({
                    id: 'meeting_dept_user_import_success'
                  })}`
              });
            }
          } else {
            Modal.error({ content: `${errorMsg || msg}` });
          }
        } else if (info.file.status === 'error') {
          Modal.error({
            content: `${info.file.name + ' ' +  _this.props.intl.formatMessage({ id: 'meeting_dept_user_file_failed' })}`
          });
        }
      }
    };
    const getTreeNode = (depts, pdept) =>
      depts.map(dept => {
        if (dept.depts && dept.depts.length) {
          return (
            <TreeNode
              key={dept.id + ''}
              deptNodeCode={dept.nodeCode}
              title={getTreeNodeTitle(dept, pdept)}
            >
              {getTreeNode(dept.depts, dept)}
            </TreeNode>
          );
        }
        return (
          <TreeNode
            key={dept.id + ''}
            deptNodeCode={dept.nodeCode}
            title={getTreeNodeTitle(dept, pdept)}
          />
        );
      });
    const getTreeNodeTitle = (dept, pdept) => {
      return (
        <div className="treeNodeTitle">
          <span className="nodeName">{dept.name}</span>
          <div className="iconList">
            <div
              title={
                dept.level != 0
                  ? intl.formatMessage({ id: 'user_add_comp_dept' })
                  : intl.formatMessage({ id: 'user_add_sub_dept' })
              }
              onClick={() => {
                this.addDept(dept);
              }}
              className="iconfont icon-tianjia1"
            />
            <div className="iconfont" />
            <div
              title={intl.formatMessage({ id: 'user_edit' })}
              style={{ visibility: dept.deptFrom == 0 ? '' : 'hidden' }}
              onClick={() => {
                this.editDept(dept, pdept);
              }}
              className="iconfont icon-75bianji"
            />
            <div className="iconfont" />
            <div
              title={intl.formatMessage({ id: 'user_delete' })}
              style={{ visibility: dept.deptFrom == 0 ? '' : 'hidden' }}
              onClick={() => {
                this.removeDept(dept);
              }}
              className="iconfont icon-shanchu"
            />
          </div>
        </div>
      );
    };
    const columns = [
      {
        title: intl.formatMessage({ id: 'index_username' }),
        width: '13%',
        key: 'displayName',
        render: (text, record) => {
          const role = allRoles.find(r => r.id === record.roleId);
          const tooltip =
            record.roleKey !== ROLES_KEY.normal ? (
              <IconTip title={role && role.name} type="role" />
            ) : null;
          return (
            <span className={`name`}>
              {record.firstName + ' ' + record.givenName}
              {tooltip}
            </span>
          );
        }
      },
      {
        title: intl.formatMessage({ id: 'user_department' }),
        width: '14%',
        key: 'dept',
        render: (text, record) => {
          return record.dept;
        }
      },
      {
        title: intl.formatMessage({ id: 'user_position' }),
        width: '14%',
        key: 'position',
        render: (text, record) => {
          return record.position;
        }
      },
      {
        title: intl.formatMessage({ id: 'index_phone' }),
        width: '12%',
        key: 'mobile',
        render: (text, record) => {
          return record.mobile;
        }
      },
      {
        title: intl.formatMessage({ id: 'index_email' }),
        width: '17%',
        key: 'email',
        render: (text, record) => {
          return record.email;
        }
      },
      {
        title: intl.formatMessage({ id: 'meeting_list_table_operate' }),
        width: '16%',
        key: 'action',
        render: (text, record) => {
          return record.userFrom === USER_FROM.local ? (
            <div>
              <OperateSpan
                onClick={this.onResetPwd.bind(this, record.userId)}
              >
                <IconTip
                  title={intl.formatMessage({ id: 'main_btn_reset_pwd' })}
                  type="mimachongzhi"
                />
              </OperateSpan>
              <OperateSpan onClick={this.editUser.bind(this, record)}>
                <IconTip
                  title={intl.formatMessage({ id: 'user_edit' })}
                  type="75bianji"
                />
              </OperateSpan>
              {record.userId === ADMIN_USER_ID ? null : (
                <OperateSpan onClick={this.delUser.bind(this, record.userId)}>
                  <IconTip
                    title={intl.formatMessage({ id: 'user_delete' })}
                    type="shanchu"
                  />
                </OperateSpan>
              )}
            </div>
          ) :  <OperateSpan onClick={this.editUser.bind(this, record)}>
            <IconTip
              title={intl.formatMessage({ id: 'user_edit' })}
              type="75bianji"
            />
          </OperateSpan>;
        }
      }
    ];
    //如果allDept为[]时渲染，会导致第一次defaultExpandAll属性失效
    if (allDept.length == 0) {
      return <div />;
    }
    return (
      <div className="duManageBorder">
        <div className="treeDiv">
          <div className="treeBorder">
            <Tree
              className="tree"
              defaultExpandAll={true}
              onSelect={this.treeSelect}
            >
              {getTreeNode(allDept)}
            </Tree>
          </div>
        </div>
        <div className="listDiv">
          <div className="listBorder">
            <div className="listTitle">
              <div className="listTitleBtn">
                <Button type="primary" icon="plus" onClick={this.addUser}>
                  <FormattedMessage id="meeting_dept_user_add" />
                </Button>
                <Upload {...uploadProps}>
                  <Button>
                    <Icon type="upload" />
                    <FormattedMessage id="meeting_dept_user_import" />
                  </Button>
                </Upload>
                <Button
                  style={{ marginLeft: '12px' }}
                  onClick={() => {
                    window.open(
                      '/syncuser/userInfo/getTemplet?token=' +
                        sessionStorage.getItem('token') +
                        '&lang=' +
                        this.props.intl.formatMessage({ id: 'locale' }),
                      '_blank'
                    );
                  }}
                >
                  <FormattedMessage id="download_template" />
                </Button>
              </div>
              <div className="listTitleInput">
                <Input
                  style={{ width: 300 }}
                  value={keyword}
                  addonBefore={
                    <Select
                      defaultValue="name"
                      value={keyType}
                      onSelect={this.onSelectKeyType}
                    >
                      <Option value="name">
                        <FormattedMessage id="index_username" />
                      </Option>
                      <Option value="dept">
                        <FormattedMessage id="user_department" />
                      </Option>
                      <Option value="position">
                        <FormattedMessage id="user_position" />
                      </Option>
                    </Select>
                  }
                  addonAfter={<Icon type="search" onClick={this.onSearch} />}
                  placeholder={intl.formatMessage({
                    id: 'main_search_keywords'
                  })}
                  onChange={this.onChangeKey}
                  onPressEnter={this.onSearch}
                />
              </div>
            </div>
            <div className="list">
              <Table
                columns={columns}
                dataSource={users}
                heght
                rowKey={record => record.id}
                pagination={
                  total > pageSize
                    ? {
                        total,
                        current,
                        pageSize,
                        onChange: this.onPageChange,
                        onShowSizeChange: this.onPageChange
                      }
                    : false
                }
              />
            </div>
          </div>
        </div>
        <DeptAddEdit
          deptAddEditStatus={deptAddEditStatus}
          deptAddEditValue={deptAddEditValue}
          deptAddEditParent={deptAddEditParent}
          onCancel={this.deptAddEditClose}
          updateAddEdit={this.updateAddEdit}
          save={this.addEditSave}
        />
        <UserAddEdit
          addEditUser={addEditUser}
          visible={userAddEditStatus > 0}
          allDept={allDept}
          onCancel={this.userAddEditClose}
        />
      </div>
    );
  }

  treeSelect = (selectedKeys, { selected, node }) => {
    if (selected) {
      const { dispatch } = this.props;
      const { deptNodeCode } = node.props;
      dispatch({
        type: 'deptUserManage/update',
        payload: { selDeptNodeCode: deptNodeCode }
      });
      dispatch({ type: 'deptUserManage/searchUsers' });
    }
  };

  onResetPwd = userId => {
    const { dispatch, intl } = this.props;
    Modal.confirm({
      content: intl.formatMessage({ id: 'meeting_pwd_reset_confirm' }),
      okText: intl.formatMessage({ id: 'dialog_btn_ok' }),
      cancelText: intl.formatMessage({ id: 'dialog_btn_cancel' }),
      onOk: () => {
        dispatch({ type: 'deptUserManage/resetPwd', userId });
      }
    });
  };
  onPageChange = (current, pageSize) => {
    const { dispatch } = this.props;
    dispatch({ type: 'deptUserManage/update', payload: { current, pageSize } });
    dispatch({ type: 'deptUserManage/searchUsers' });
  };

  onSelectKeyType = value => {
    this.setState({ keyType: value });
  };

  onSelectKeyType = value => {
    const { dispatch } = this.props;
    dispatch({
      type: 'deptUserManage/update',
      payload: { keyType: value }
    });
  };
  onChangeKey = e => {
    const { dispatch } = this.props;
    dispatch({
      type: 'deptUserManage/update',
      payload: { keyword: e.target.value }
    });
  };
  onSearch = () => {
    const { dispatch } = this.props;
    const { keyword, keyType } = this.state;
    dispatch({ type: 'deptUserManage/searchUsers' });
  };

  addEditSet = setVal => {
    const { dispatch } = this.props;
    if (setVal.type == 'dept') {
      dispatch({
        type: 'deptUserManage/update',
        payload: { deptAddEditStatus: setVal.deptAddEditStatus }
      });
      this.setState({
        deptAddEditValue: setVal.deptAddEditValue,
        deptAddEditParent: setVal.deptAddEditParent
      });
    }
    if (setVal.type == 'user') {
      dispatch({
        type: 'deptUserManage/update',
        payload: { userAddEditStatus: setVal.userAddEditStatus }
      });
      this.setState({ addEditUser: setVal.addEditUser });
    }
  };
  delUser = userId => {
    const { dispatch, intl } = this.props;
    Modal.confirm({
      content: intl.formatMessage({ id: 'meeting_user_delete_confirm' }),
      okText: intl.formatMessage({ id: 'dialog_btn_ok' }),
      cancelText: intl.formatMessage({ id: 'dialog_btn_cancel' }),
      onOk: () => {
        dispatch({ type: 'deptUserManage/delUser', userId });
      }
    });
  };
  editUser = user => {
    this.addEditSet({
      type: 'user',
      userAddEditStatus: 2,
      addEditUser: user
    });
  };
  addUser = () => {
    const { selDeptNodeCode } = this.props;
    this.addEditSet({
      type: 'user',
      userAddEditStatus: 1,
      addEditUser: { deptNodeCode: selDeptNodeCode }
    });
  };

  userAddEditClose = () => {
    this.addEditSet({ type: 'user', userAddEditStatus: 0, addEditUser: {} });
  };

  addDept = dept => {
    this.addEditSet({
      type: 'dept',
      deptAddEditStatus: 1,
      deptAddEditValue: { name: '', level: '0' },
      deptAddEditParent: dept
    });
  };
  editDept = (dept, pdept) => {
    this.addEditSet({
      type: 'dept',
      deptAddEditStatus: 2,
      deptAddEditValue: {
        id: dept.id,
        name: dept.name,
        level: dept.level + ''
      },
      deptAddEditParent: pdept
    });
  };
  updateAddEdit = (type, name, vale) => {
    if (type == 'dept') {
      const { deptAddEditValue } = this.state;
      deptAddEditValue[name] = vale;
      this.setState({ deptAddEditValue: { ...deptAddEditValue } });
    }
  };
  addEditSave = type => {
    if (type == 'dept') {
      const { deptAddEditStatus, dispatch } = this.props;
      const { deptAddEditValue, deptAddEditParent } = this.state;
      if (deptAddEditStatus == 1) {
        dispatch({
          type: 'deptUserManage/saveDept',
          parId: deptAddEditParent.id,
          level: deptAddEditValue.level,
          sonName: deptAddEditValue.name
        });
      }
      if (deptAddEditStatus == 2) {
        dispatch({
          type: 'deptUserManage/updateDept',
          deptId: deptAddEditValue.id,
          name: deptAddEditValue.name
        });
      }
    }
  };
  removeDept = dept => {
    const { intl } = this.props;
    Modal.confirm({
      content: intl.formatMessage({ id: 'meeting_dept_delete_confirm' }),
      okText: intl.formatMessage({ id: 'dialog_btn_ok' }),
      cancelText: intl.formatMessage({ id: 'dialog_btn_cancel' }),
      onOk: () => {
        const { dispatch } = this.props;
        dispatch({
          type: 'deptUserManage/deleteDept',
          deptId: dept.id
        });
      }
    });
  };
  deptAddEditClose = () => {
    this.addEditSet({
      type: 'dept',
      deptAddEditStatus: 0,
      deptAddEditValue: {},
      deptAddEditParent: {}
    });
  };
}

const mapStateToProps = state => {
  const { deptUserManage, i18n, role } = state;
  deptUserManage.i18n = i18n;
  deptUserManage.allRoles = role.roleMenus;
  return { ...deptUserManage };
};

export default connect(mapStateToProps)(injectIntl(DeptUserManage));



// WEBPACK FOOTER //
// ./src/routes/SystemConfig/DeptUserManage/DeptUserManage.js